export const GET_TAGGED_COURSES_STATS = 'GET_TAGGED_COURSES_STATS';
